import { render, staticRenderFns } from "./CreateContactFromList.vue?vue&type=template&id=712e8f6c&"
import script from "./CreateContactFromList.vue?vue&type=script&lang=js&"
export * from "./CreateContactFromList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports